import React, { Fragment, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import LogoutButton from './LogoutButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import { Icon } from '@material-ui/core';
import { useAuthDataContext, UserRoles } from './AuthDataProvider';
const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
        backgroundColor: '#6C6056'
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 480,
    },
}));

export default function Naviagtion() {
    const { user } = useAuthDataContext();

    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    useEffect(() => {
        user ? setOpen(true) : setOpen(false)
    }, [user]);

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (

        <Fragment>

            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    {user ? <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}>
                        <Icon>menu</Icon>
                    </IconButton> : null}
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        Analytics Review Tool
                    </Typography>
                    <div><Link to={"/user/" + user?.user_details?.user_id}>{user?.user_details?.email}</Link>
                    <LogoutButton /></div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <Icon>chevron_left</Icon>
                    </IconButton>
                </div>
                <Divider />
                {user ? <List>
                    <div>
                        <Link to="/water" style={{ color: 'white', textDecoration: 'none' }}>
                            <ListItem button>
                                <ListItemIcon>
                                    <Icon>surfing</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Water Events" />
                            </ListItem>
                        </Link>
                    </div>
                    <div>
                        <Link to="/sentree" style={{ color: 'white', textDecoration: 'none' }}>
                            <ListItem button>
                                <ListItemIcon>
                                    <Icon>ac_unit</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Sentree Events" />
                            </ListItem>
                        </Link>
                    </div>
                    <div>
                        <Link to="/rheem/dashboard" style={{ color: 'white', textDecoration: 'none' }}>
                            <ListItem button>
                                <ListItemIcon>
                                    <Icon>smart_toy</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Rheem" />
                            </ListItem>
                        </Link>
                    </div>
                    {user.roles.includes(UserRoles.admin) ?
                    <div>
                        <Link to="/users" style={{ color: 'white', textDecoration: 'none' }}>
                            <ListItem button>
                                <ListItemIcon>
                                    <Icon>people</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Users" />
                            </ListItem>
                        </Link>
                    </div>
                    : null}
                    <div>
                        <Link to="/export" style={{ color: 'white', textDecoration: 'none' }}>
                            <ListItem button>
                                <ListItemIcon>
                                    <Icon>people</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Export" />
                            </ListItem>
                        </Link>
                    </div>
                </List> : null}
            </Drawer></Fragment>
    );
}
